
import { Component, Vue, Watch } from "vue-property-decorator";
import { Field, Toast } from "vant";
import { Getter } from "vuex-class";
import { shareFileToWeixin } from '@/utils/h5ToApp'
import { pxToVw } from "@/utils/pxToVw";
import { joinExport } from '@/api/jielong'
import {
  getJoinOrderData,
  directRedemption,
  batchShip,
  pickUpGoods,
  getJoinGoodsList,
  getJoinGoodsData,
  saveStoreRemark
} from "@/api/jielong";
import SearchBar from "@/components/SearchBar/index.vue";
import ExportDataPopup from "@/views/jielongOrder/components/ExportDataPopup.vue";
import { downloadUrl } from "@/utils/util";
import { exportFile } from '@/utils/fileUtil'
const PLACEHOLDER = require("@/assets/images/shouyin/shopManage/shelf-manage.png");

@Component({
  components: { SearchBar, ExportDataPopup },
})
export default class JielongOrder extends Vue {
  @Getter companyId!: string;
  @Getter bottomSafetyHeight!: number;
  downloadUrl = downloadUrl;

  // 顶部汇总商品数据
  JoinGoodsDataDtl = {}
  checkedList = [];
  showClassify = false;
  classify = [
    { label: '全部备注', value: '' },
    { label: '商家备注', value: 2 },
    { label: '客户备注', value: 1 }
  ];

  // 正式参数：存储value，请求后端用这个值
  currentType = '';
  // 弹窗临时缓存value
  tempValue = '';

  statusOptions = [
    { name: '全部', value: '', color: '#86909C', isTab: true }, // value对应的是订单状态
    { name: '待发货/提货', value: '1', color: '#FD8305', isTab: true },
    { name: '已发货/提货', value: '2', color: '#FD8305', isTab: true },
    { name: '已取消', value: '-1', color: '#86909C', isTab: true }
  ]

  curTab: any = ''
  // 订单商品数组
  orderList = []

  JoinOrderDataDtl:any = {
    totalOrderCount:0,
    totalSaleMoney:0,
    totalReturnMoney:0
  } // 订单汇总数据
  currentItem:any = {
    orderId: ''
  }

  // 实收金额
  totalPrice = "7,999.50";
  refreshing = false
  loading = false
  finished = false
  remark = ''
  // 缓存当前正在编辑的订单下标
  currentEditIndex = null
  getCode = '' // 订单提货码
  showEmail = false // 导出邮箱弹窗
  email = '' // 邮箱字段

  // 当前弹窗类型 addRemark / send / get / off / email
  dialogType = ""
  dialogShow = false
  // 弹窗标题映射对象
  dialogTitleMap = {
    addRemark: "添加备注",
    send: "确认订单发货？",
    get: "订单提货",
    off: "确认订单直接核销？",
    email: "导出到邮箱"
  }

   // 弹窗开关
  showExportPopup = false
  // 当前激活tab
  activeExportTab = 0
  tabList = ["按商品导出", "按订单/客户导出"]

  // 【按商品导出】模拟预览数据
  goodsExportList = [
    {
      goodsName: '大白菜(1份)',
      num: 38,
      price: 189.62,
      personNum: 10,
      arriveDate: '05月20日'
    },
    {
      goodsName: '鲜牛肉(1kg)',
      num: 55,
      price: 2304.5,
      personNum: 20,
      arriveDate: '05月20日'
    }
  ]

  // 【按订单客户导出】模拟预览数据
  orderExportList = [
    {
      customerName: '张** (18823396271)',
      goodsName: '大白菜(1份)',
      num: 2,
      remark: '尽量上午送达',
      orderStatus: '待提货'
    },
    {
      customerName: '张** (18823396271)',
      goodsName: '大白菜(1份)',
      num: 2,
      remark: '',
      orderStatus: '待提货'
    }
  ]

  params = {
    pageIndex: 1,
    pageSize: 10,
    joinActivityId: '',
    orderStatus:'',  // 1待发货/提货， 2已发货/提货， -1已取消
    distributionType:'', // 1提货、2发货
    queryContent: "",
    remarkType: "",  // 1客户备注 2商家备注
    goodsList: []
  };
  totalRecords = 0

  mounted() {
    this.params.joinActivityId = this.$route.query.id as string
    // this.params.joinActivityId = '6a549d03639c1195c049a606'
    this.getJoinOrderDataDtl()
    this.getJoinGoodsDataDtl()
    this.getJoinGoodsListData()
  }

  imageSrc (item) {
    if (!item.headImg) return PLACEHOLDER;
    const path = item.headImg;
    if (/^https?:\/\//i.test(path)) return path;
    const sftpUrl = this.$store.state.user.sftpUrl || "";
    if (sftpUrl) return sftpUrl + path;
    return downloadUrl(path);
  }

  onlyNumber() {
    this.getCode = this.getCode.replace(/[^\d]/g, '');
  }
  // 获取订单汇总数据
  getJoinOrderDataDtl() {
    getJoinOrderData({
      storeId: this.companyId,
      joinActivityId: this.params.joinActivityId
    }).then((res: any) => {
      console.log('res', res)
      // this.JoinOrderDataDtl = res.data
      Object.assign(this.JoinOrderDataDtl, res.data)
      this.$forceUpdate()
    })
  }

  // 下载转发微信
  downloadWechat(activeTab?: number) {
    const tab = activeTab != null ? activeTab : this.activeExportTab
    this.activeExportTab = tab
    const type = tab === 0 ? 1 : 2
    const typeName = type === 1 ? '按商品导出' : '按订单/客户导出'
    const now = new Date()
    const month = now.getMonth() + 1
    const day = now.getDate()
    const dateStr = `${now.getFullYear()}${month < 10 ? '0' + month : month}${day < 10 ? '0' + day : day}`
    const title = `接龙活动${typeName}${dateStr}`
    joinExport({
      joinActivityId: this.params.joinActivityId,
      type
    }).then((res: any) => {
      // exportFile(res.data, '1.xlsx')
      // 假设 response.data 是接口返回的二进制数据（ArrayBuffer 或 Blob）
      const blob = new Blob([res.data], { type: 'application/octet-stream' });

      const reader = new FileReader();
      reader.onload = function(e: any) {
          // e.target.result 就是完整的 data: URL，包含 Base64 编码
          // const base64DataUrl = e.target.result;
          // 如果只要纯 Base64 字符串，可以去掉前缀
          const base64String = e.target.result.split(',')[1];
          console.log(base64String);
          shareFileToWeixin({
            fileBase64: base64String,
            title,
            fileExtension: "xlsx",
            scene: "session"
          });
      };
      reader.readAsDataURL(blob);
    })
  }

  // 导出到邮箱
  exportEmail() {
    this.showEmail = true
  }

  changeTab(index: any){
    this.activeExportTab = index
  }

  // 邮箱校验方法
  checkEmailFormat(emailStr: string): boolean {
    // 标准邮箱正则
    const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/
    return reg.test(emailStr)
  }

  // 编辑商家备注
  editRemark(index: number) {
    this.currentEditIndex = index
    // 把原有备注回填到输入框
    this.remark = this.orderList[index].orderStoreRemark
    // this.showAdd = true
  }

  // 发货、提货、直接核销
  handleDialog(type: string, item: any, index?: number) {
    this.currentItem = item
    console.log(item)
    if (index !== undefined) {
      this.currentEditIndex = index
    }
    if (type === 'off') {
      this.openDialog('off')
    } else if(type === 'send'){
      this.openDialog('send')
    } else if (type==='get') {
      this.openDialog('get')
    } else if(type === 'addRemark') {
      // 回填商家备注
      this.remark = item.orderStoreRemark ?? ''
      this.openDialog('addRemark')
    } else if(type === 'email') {
      this.openDialog('email')
    }
  }

  // 计算属性动态标题
  get dialogTitle() {
    return this.dialogTitleMap[this.dialogType] || ""
  }

  openDialog(type: string) {
    this.dialogType = type
    this.dialogShow = true
    // 打开弹窗时按需清空对应输入值
    // addRemark 不要清空，数据在handleDialog回填
    if (type === 'get') this.getCode = ''
    if (type === 'email') this.email = ''
  }

  // 批量处理
  
  handleCancel() {
    this.dialogShow = false
  }

  async handleAllConfirm() {
    const type = this.dialogType
    if (type === 'off') {
      console.log('直接核销')
      directRedemption({
        orderId: this.currentItem.orderId
      }).then((res: any) => {
        this.dialogShow = false
        this.$toast.success('核销成功')
        // 重新获取列表数据
        this.getJoinGoodsListData()
        this.getJoinOrderDataDtl()
        this.getJoinGoodsDataDtl()
      })
    } else if (type === 'send') {
      console.log('发货')
      batchShip({
        orderList: [{
          orderId: this.currentItem.orderId
        }]
      }).then((res: any) => {
        this.dialogShow = false
        this.$toast.success('发货成功')
        // 重新获取列表数据
        this.getJoinGoodsListData()
        this.getJoinOrderDataDtl()
        this.getJoinGoodsDataDtl()
      })
    } else if (type === 'get') {
      console.log('提货')
      pickUpGoods({
        storeId: this.companyId,
        orderId: this.currentItem.orderId,
        joinActivityId: this.params.joinActivityId,
        pickUpCode: this.getCode
      }).then((res: any) => {
        this.dialogShow = false
        this.$toast.success('提货成功')
        // 重新获取列表数据
        this.getJoinGoodsListData()
        this.getJoinOrderDataDtl()
        this.getJoinGoodsDataDtl()
      })
    } else if (type === 'email') {
      const value = this.email.trim()
      // 1.非空校验
      if (!value) {
        this.$toast('请输入邮箱地址')
        return
      }
      // 2.格式正则校验
      if (!this.checkEmailFormat(value)) {
        this.$toast('邮箱格式不正确，请重新输入')
        this.email = ''
        return
      }
      this.dialogShow = false
      this.$toast('导出请求已提交，请查收邮箱')
    } else if (type === 'addRemark') {
      const name = this.remark.trim()
      // 非空校验
      if (!name) {
        this.$toast('请输入备注内容')
        return
      }
      if (this.currentEditIndex !== null) {
        // 将新备注赋值到对应订单
        this.orderList[this.currentEditIndex].orderStoreRemark = name
      }
      saveStoreRemark({
        storeId: this.companyId,
        orderId: this.currentItem.orderId,
        orderStoreRemark: this.orderList[this.currentEditIndex].orderStoreRemark
      }).then((res: any) => {
        this.dialogShow = false
        this.$toast.success('备注修改成功')
      })
    }
  }

  // 批量处理
  batchData() {
    this.$router.push('/batchOrder')
    this.$router.push({
      path: '/batchOrder',
      query: { joinActivityId: this.params.joinActivityId },
    });
  }

  // 导出数据
  exportData() {
    console.log("导出数据", this.orderList.length);
    if(!this.orderList.length){
      this.$toast({
        message: '暂无导出数据',
      })
      return
    }
    this.showExportPopup = true
    this.activeExportTab = 0 // 默认选中第一个tab
  }

  get tabs () {
    return this.statusOptions.filter((item: any) => item.isTab)
  }

  changeTabs () {
    document.querySelector('.order-scroll').scrollTop = 0
    this.params.pageIndex = 1
    this.params.orderStatus = this.curTab
    this.getJoinGoodsListData()
  }

  onChange(){
    console.log('checkedList------', this.checkedList)
    this.params.goodsList = this.checkedList.map(goodsId => ({ goodsId }))
    this.getJoinGoodsListData()
  }

  // 根据value反向获取label，用于页面回显展示
  getCurrentLabel() {
    const target = this.classify.find(item => item.value === this.currentType)
    return target ? target.label : '全部备注';
  }

  onSearch() {
    // ========== 后端请求参数直接使用 currentType（value值） ==========
    console.log('传给后端的参数value：', this.currentType)
    // 接口调用示例
    // const params = {
    //   keyword: this.queryContent,
    //   remarkType: this.currentType, // 后端字段
    //   companyId: this.companyId
    // }
    // this.api.getList(params)
    this.getJoinGoodsListData()
  }

  // 打开弹窗：复制正式value到临时变量，实现选中回显高亮
  openClassify() {
    this.tempValue = this.currentType;
    this.showClassify = true;
  }

  // 取消关闭：currentType完全不变，上次选择的数据保留
  popupClose() {
    this.showClassify = false;
  }

  // 确认：临时value赋值给正式参数，生效
  confirmSelect() {
    this.currentType = this.tempValue;
    this.params.remarkType = this.currentType
    this.showClassify = false;
    // 需要确认后自动搜索，放开下面代码
    this.getJoinGoodsListData()
  }
    /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getJoinGoodsListData()
    this.getJoinOrderDataDtl()
    this.getJoinGoodsDataDtl()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++;
    this.getJoinGoodsListData();
  }

  getJoinGoodsDataDtl(){
    getJoinGoodsData({
      storeId: this.companyId,
      joinActivityId: this.params.joinActivityId
    }).then((res) => {
      this.JoinGoodsDataDtl = {...res.data}
    })
  }

  computeSatus(item: any) {
   let data = {
    statusText: '',
    color: "#FD8305"
   }
    if (item.orderStatus === -1) {
      data.statusText = '已取消'
      data.color = '#F44336'
    } else if (item.orderStatus === -2) {
      data.statusText = '退款/退货'
      data.color = '#F44336'
    } else if (item.orderStatus === 1) {
      data.statusText = item.distributionType === 1 ? '待提货' : '待发货'
      data.color = "#FD8305"
    } else if (item.orderStatus === 2) {
      data.statusText =  '已发货'
      data.color = '#86909C'
    } else if (item.orderStatus === 3) {
      data.statusText = item.distributionType === 2 ? ' 已发货' : '已提货'
      data.color = '#86909C'
    }
    return data
  }

  getJoinGoodsListData () {
    getJoinGoodsList({
      storeId: this.companyId,
      //storeId: "6865ebf0d5e8c8706bfc593c",
      ...this.params,
      orderStatus: this.curTab
    })
      .then((res) => {
        console.log('订单数据', res)
        if (this.refreshing || this.params.pageIndex === 1) {
          this.orderList = [];
        }
        this.orderList = this.orderList.concat(res.data.records);
        this.totalRecords = res.data.totalRecords
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  get bottomSafetyHeightVw(): string {
    return this.bottomSafetyHeight ? pxToVw(this.bottomSafetyHeight) : pxToVw(12);
  }
}
